import { useState, useEffect, useCallback } from "react";
import { formatTime } from "@/utils/date.utils";

interface UseTimerProps {
  initialTime?: number;
  onComplete?: () => void;
}

export function useTimer({ initialTime = 60, onComplete }: UseTimerProps = {}) {
  const [timer, setTimer] = useState(initialTime);
  const [isCompleted, setIsCompleted] = useState(false);

  useEffect(() => {
    const countdown = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
          clearInterval(countdown);
          setIsCompleted(true);
          onComplete?.();
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);

    return () => clearInterval(countdown);
  }, [isCompleted, onComplete]);

  const resetTimer = useCallback((newInitialTime?: number) => {
    setTimer(newInitialTime ?? initialTime);
    setIsCompleted(false);
  }, [initialTime]);

  return {
    timer,
    isCompleted,
    resetTimer,
    formattedTime: formatTime(timer)
  };
} 